module.exports = __webpack_public_path__ + "img/panorama-device.cef16891.png";